import { ScoringCardsClient } from "@topline/services/apiService";
import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { Gen } from "@topline/services/api";
import { GridOptions } from "ag-grid-community";
import ng from "angular";
import _ from "underscore";
import thickElement from "../../../../images/silver-icon/thick-element.png";
import { isTrue } from "../../../Services/boolean";
import { IdSvrAuthService } from "../../../auth/idSrvAuthService";
import { ScoringCardForecastsComponent } from "./scoringCardForecasts.component";

export class ScoringCardsReportComponentController {
    public canExportBudgetVersionToML: boolean;
    public gridApi: $TSFixMe;
    public exportedBudgetVersionUId: $TSFixMe;
    public scoringCardsReportGrid: GridOptions;
    public selectedBudgetVersion?: Gen.BudgetVersionDTO;

    static $inject = [
        IdSvrAuthService.componentName,
        AgGridService.componentName,
        angularServicesNames.$translate,
        ScoringCardsClient.componentName,
        angularServicesNames.$uibModal
    ];

    constructor(
        private authService: IdSvrAuthService,
        private agGridService: AgGridService,
        private $translate: ng.translate.ITranslateService,
        private scoringCardsClient: ScoringCardsClient,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private budgetVersions: Gen.BudgetVersionDTO[]
    ) {}

    $onInit() {
        this.authService
            .hasPermissionAsync("ExportBudgetVersionToML")
            .then(hasPermission => (this.canExportBudgetVersionToML = hasPermission));

        this.selectedBudgetVersion = _.chain(this.budgetVersions)
            .filter(v => v.isEditable)
            .first()
            .value();

        this.initializeGrid();
    }

    reloadPageSize(pageSize: $TSFixMe) {
        if (this.gridApi) {
            this.gridApi.paginationSetPageSize(pageSize);
        }
    }

    refreshGrid() {
        if (!this.selectedBudgetVersion) return;
        this.gridApi.showLoadingOverlay();
        this.scoringCardsClient.getReport(this.selectedBudgetVersion!.versionId).then(items => {
            this.gridApi.setRowData(items);

            this.exportedBudgetVersionUId = _.chain(items)
                .filter((f: $TSFixMe) => f.markedForExport)
                .pluck("versionUId")
                .first()
                .value();
        });
    }

    budgetVersionChanged() {
        this.refreshGrid();
    }

    showForecasts = (scoringCard: Gen.ScoringCardReportItemDTO) => {
        var modalInstance = this.$uibModal.open({
            animation: true,
            component: ScoringCardForecastsComponent.componentName,
            size: "lg",
            resolve: {
                name: () => scoringCard.scoringCardName,
                forecasts: () => scoringCard.forecasts
            }
        });
        modalInstance.result.then(
            () => {},
            () => {}
        );
    };

    private initializeGrid() {
        this.scoringCardsReportGrid = {
            columnDefs: [
                // Column definitions go here
                {
                    headerValueGetter: () => this.$translate.instant("SCORING_CARDS.REPORT.GRID.HEADER"),
                    children: [
                        {
                            headerValueGetter: () =>
                                this.$translate.instant("SCORING_CARDS.REPORT.GRID.SCORING_CARD_NAME"),
                            field: "scoringCardName",
                            filter: "agTextColumnFilter"
                        },
                        {
                            headerValueGetter: () =>
                                this.$translate.instant("SCORING_CARDS.REPORT.GRID.HAS_MARKET_CREATED"),
                            field: "hasMarketCreated",
                            filter: "agSetColumnFilter",
                            cellRenderer: params =>
                                params.data && params.data.hasMarketCreated
                                    ? `<div class="ui-grid-cell-contents"><img src="${thickElement}"><div/>`
                                    : "",
                            filterParams: {
                                cellRenderer: (params: $TSFixMe) => {
                                    return params.value != null
                                        ? this.$translate.instant(isTrue(params.value) ? "YES" : "NO")
                                        : "";
                                }
                            }
                        },
                        {
                            headerValueGetter: () => this.$translate.instant("SCORING_CARDS.REPORT.GRID.MARKET_NAME"),
                            field: "marketName",
                            filter: "agTextColumnFilter",
                            cellRenderer: params =>
                                params.data.hasMarketCreated
                                    ? params.data.marketType === Gen.MarketType.ScoringCardsPoland
                                        ? `<div class="ui-grid-cell-contents">
                                        <a ui-sref="market.edit-scoringcardspoland({ id : data.marketId })">${params.data.marketName}</a>
                                    </div>`
                                        : `<div class="ui-grid-cell-contents">
                                        <a ui-sref="market.edit-scoringcards({ id : data.marketId })">${params.data.marketName}</a>
                                    </div>`
                                    : "",
                            cellStyle: params => (params.data.isEditable ? { fontWeight: "bold" } : "")
                        },
                        {
                            headerValueGetter: () =>
                                this.$translate.instant("SCORING_CARDS.REPORT.GRID.FORECASTS_NUMBER"),
                            field: "forecasts.length",
                            filter: false,
                            cellRenderer: params =>
                                params.data && params.data.forecasts.length
                                    ? `<div href="#" ng-click="$ctrl.showForecasts(data)" class="ui-grid-cell-contents"><a>${params.data.forecasts.length}<i class="margin-left-4 glyphicon glyphicon-list"></i></a></div>`
                                    : params.data.forecasts.length
                        }
                    ]
                }
            ],
            floatingFilter: true,
            angularCompileRows: true,
            defaultColDef: {
                filter: true,
                sortable: true,
                resizable: true
            },
            getRowNodeId: data => data.scoringCardId,
            animateRows: true,
            pagination: true,
            rowGroupPanelShow: "never",
            suppressMultiSort: true,
            paginationPageSize: 10,
            domLayout: "autoHeight",
            popupParent: document.getElementById("scoringCardsReportGrid")!,
            localeTextFunc: this.agGridService.transalteFunc,
            suppressHorizontalScroll: true,
            onGridReady: config => {
                this.gridApi = config.api;
                config.api.sizeColumnsToFit();
                this.refreshGrid();
            },
            onGridSizeChanged: config => config.api.sizeColumnsToFit()
        };
    }
}

export class ScoringCardsReportComponent implements ng.IComponentOptions {
    static componentName = "scoringCardsReport";
    bindings = {
        budgetVersions: "<"
    };
    controller = ScoringCardsReportComponentController;
    template = require("./scoringCardsReport.component.html");
}

angular
    .module("topline.modules")
    .component(ScoringCardsReportComponent.componentName, new ScoringCardsReportComponent());
